import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { mainColors } from 'src/assets/colors';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

export const InfoErrorIcon = observer(
    ({ className, onClick }: PropsType): React.ReactElement => (
        <SvgWrapper
            width={16}
            height={16}
            className={className}
            onClick={onClick}
            fill={mainColors.main.secondary}
            viewBox='0 0 16 16'
        >
            <circle
                cx='8'
                cy='8'
                r='7'
                fill={mainColors.status.error}
            />
            <text
                x='8'
                y='12'
                textAnchor='middle'
                fill='white'
                fontSize='12'
                fontWeight='bold'
                fontFamily='Arial'
            >
                !
            </text>
        </SvgWrapper>
    )
);
